import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const CalendarComponent = React.lazy(() => import("../Components/RootComponents/CalendarComponent"));
const CalendarPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <CalendarComponent />
      </Suspense>
    </Fragment>
  );
};

export default CalendarPage;
